module.exports = __webpack_public_path__ + "static/media/ryde_user.99dc7772.png";